import Image from "components/imageNew/image";
import type { CareerBenefit } from "../types";

export default function BenefitSection({ heading, benefitList }) {
  return (
    <div className="mb-[70px]">
      <h2 className="mb-[12px] font-bold text-[18px]">{heading}</h2>
      <div className="grid grid-cols-1 gap-y-[10px] md:grid-cols-2 md:gap-x-[30px] md:gap-y-5 lg:grid-cols-3 lg:gap-x-[20px] lg:gap-y-[20px]">
        {benefitList.length &&
          benefitList.map((benefit: CareerBenefit, i: number) => {
            return (
              <div
                key={i}
                className="flex flex-col items-center justify-center bg-[#F0F0F0] py-5 md:py-[30px] lg:h-[214px]"
              >
                <Image
                  className="mb-3 h-[96px] w-[131px] object-contain md:mb-4 md:h-[99px] md:w-[130px] lg:w-auto lg:shrink-0"
                  src={benefit.hiringBenefitImage?.url}
                  height={benefit.hiringBenefitImage?.height}
                  width={benefit.hiringBenefitImage?.width}
                  alt={benefit.hiringBenefitImage?.alt || ""}
                  blurDataURL={benefit.hiringBenefitImage?.blurUpThumb}
                  sizes="131px"
                />
                <p className="mx-auto max-w-[275px] text-center font-bold text-[18px] leading-[130%] text-mono-40">
                  {benefit.hiringBenefitTitle}
                </p>
              </div>
            );
          })}
      </div>
    </div>
  );
}
